import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const NewsRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100% - 200px);
`;

export const HeaderWrapper = styled.div`
  z-index: calc(var(--z-index-sidebar) - 1);
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 80px;
  width: 100%;
  padding: 0 20px;
  background-color: var(--background-default);
`;

export const NewsTitle = styled.h1`
  ${typographyV2.titleLg};
`;
